<div class="boq-explorer">
  <header class="boq-explorer-head">
    <h2>Project explorer</h2>
    <p>NH / SH corridor layers</p>
  </header>
  <ul class="boq-tree">
    <li *ngFor="let node of wb.tree" [class.has-children]="!!node.children?.length">
      <div class="boq-tree-row">
        <button
          *ngIf="node.children?.length"
          type="button"
          class="boq-twist"
          (click)="toggleExpand(node, $event)"
          [attr.aria-expanded]="isExpanded(node.id)"
        >
          {{ isExpanded(node.id) ? '▾' : '▸' }}
        </button>
        <span *ngIf="!node.children?.length" class="boq-twist-spacer"></span>
        <label>
          <input type="checkbox" [checked]="isOn(node.id)" (change)="onCheck(node.id, $event)" />
          {{ node.label }}
        </label>
      </div>
      <ul *ngIf="node.children?.length && isExpanded(node.id)" class="boq-tree boq-tree-nested">
        <li *ngFor="let child of node.children">
          <div class="boq-tree-row">
            <span class="boq-twist-spacer"></span>
            <label>
              <input type="checkbox" [checked]="isOn(child.id)" (change)="onCheck(child.id, $event)" />
              {{ child.label }}
            </label>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>
